(() => {
  if (customElements.get('frames-instagram-ready')) return;
  customElements.define('frames-instagram-ready', class extends HTMLElement {});
  const instances = new Map();
  function initialize(scope = document) {
    scope.querySelectorAll('[data-instagram-section]').forEach(section => {
      if (instances.has(section)) return;
      const dialog = section.querySelector('dialog');
      if (!dialog?.showModal) return;
      const player = section.querySelector('[data-instagram-player]');
      const source = section.querySelector('[data-instagram-source]');
      const loading = section.querySelector('[data-instagram-loading]');
      const status = section.querySelector('[data-instagram-status]');
      const poster = section.querySelector('[data-instagram-poster]');
      const events = new AbortController();
      const options = {signal: events.signal};
      let trigger, timeout, activeVideo;
      section.addEventListener('click', event => {
        const link = event.target.closest('[data-instagram-open]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const src = link.dataset.videoSrc;
        if (!src) return;
        event.preventDefault();
        trigger = link;
        const video = document.createElement('video');
        video.setAttribute('aria-label', link.getAttribute('aria-label'));
        video.controls = true;
        video.playsInline = true;
        video.preload = 'none';
        video.muted = true;
        activeVideo = video;
        source.href = link.href;
        clearTimeout(timeout);
        loading.hidden = false;
        status.textContent = status.dataset.loadingLabel;
        const preview = link.querySelector('img');
        if (preview) video.poster = poster.src = preview.currentSrc || preview.src;
        video.addEventListener('loadeddata', () => {
          clearTimeout(timeout);
          loading.hidden = true;
        }, {once: true});
        video.addEventListener('error', () => {
          clearTimeout(timeout);
          status.textContent = status.dataset.slowLabel;
        }, {once: true});
        dialog.showModal();
        player.replaceChildren(video);
        video.src = src;
        timeout = setTimeout(() => { status.textContent = status.dataset.slowLabel; }, 12000);
        video.play().catch(() => {
          if (activeVideo !== video) return;
          clearTimeout(timeout);
          loading.hidden = true;
        });
      }, options);
      section.querySelector('[data-instagram-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => { if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }}, options);
      dialog.addEventListener('close', () => {
        clearTimeout(timeout);
        activeVideo?.pause();
        activeVideo?.removeAttribute('src');
        activeVideo?.load();
        activeVideo = null;
        player.replaceChildren();
        loading.hidden = true;
        trigger?.focus({preventScroll: true});
      }, options);
      instances.set(section, () => {clearTimeout(timeout); dialog.close(); player.replaceChildren(); events.abort();});
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [section, dispose] of instances) if (event.target.contains(section)) {dispose(); instances.delete(section);}
  });
})();
